import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import gaTrackingService from '../../services/gaTrackingService';

const SearchBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchQuery, setSearchQuery] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const searchRef = useRef(null);

  const mockSuggestions = [
    { id: 1, name: 'Ristorante La Dolce Vita', category: 'Ristoranti', icon: 'UtensilsCrossed' },
    { id: 2, name: 'Boutique Eleganza', category: 'Moda', icon: 'Shirt' },
    { id: 3, name: 'Caffè Centrale', category: 'Bar & Caffè', icon: 'Coffee' },
    { id: 4, name: 'Libreria Moderna', category: 'Cultura', icon: 'BookOpen' },
    { id: 5, name: 'Farmacia San Marco', category: 'Salute', icon: 'Pill' }
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef?.current && !searchRef?.current?.contains(event?.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    if (searchQuery?.trim()?.length > 0) {
      const filtered = mockSuggestions?.filter(item =>
        item?.name?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
        item?.category?.toLowerCase()?.includes(searchQuery?.toLowerCase())
      );
      setSuggestions(filtered);
      setIsOpen(true);
    } else {
      setSuggestions([]);
      setIsOpen(false);
    }
  }, [searchQuery]);

  const handleSearchSubmit = (e) => {
    e?.preventDefault();
    if (searchQuery?.trim()) {
      // Track search in GA4
      gaTrackingService?.trackSearch({
        searchTerm: searchQuery?.trim(),
        resultsCount: suggestions?.length
      });

      navigate(`/main-storefronts?search=${encodeURIComponent(searchQuery)}`);
      setIsOpen(false);
    }
  };

  const handleSuggestionClick = (suggestion, index) => {
    // Track suggestion click in GA4
    gaTrackingService?.trackSearchSuggestionClick({
      suggestionName: suggestion?.name,
      suggestionCategory: suggestion?.category,
      searchTerm: searchQuery,
      position: index
    });

    setSearchQuery(suggestion?.name);
    navigate(`/store-details?id=${suggestion?.id}`);
    setIsOpen(false);
  };

  const isSearchPage = location?.pathname === '/main-storefronts' || location?.pathname === '/interactive-map';

  if (!isSearchPage) {
    return null;
  }

  return (
    <div ref={searchRef} className="relative w-full max-w-2xl mx-auto mb-6">
      <form onSubmit={handleSearchSubmit}>
        <div className="relative">
          <input
            type="search"
            placeholder="Cerca attività, categorie, promozioni..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e?.target?.value)}
            onFocus={() => searchQuery?.trim() && setIsOpen(true)}
            className="w-full h-12 pl-12 pr-4 rounded-lg border border-input bg-background text-foreground placeholder:text-muted-foreground transition-smooth focus:outline-none focus:ring-3 focus:ring-ring focus:ring-offset-3 focus:border-primary"
          />
          <Icon
            name="Search"
            size={20}
            className="absolute left-4 top-1/2 -translate-y-1/2 text-muted-foreground"
          />
        </div>
      </form>
      {isOpen && suggestions?.length > 0 && (
        <>
          <div
            className="fixed inset-0 z-1050"
            onClick={() => setIsOpen(false)}
          />
          <div className="absolute top-full left-0 right-0 mt-2 bg-popover rounded-lg shadow-warm-lg z-1050 overflow-hidden max-h-96 overflow-y-auto">
            <div className="py-2">
              {suggestions?.map((suggestion, index) => (
                <button
                  key={suggestion?.id}
                  onClick={() => handleSuggestionClick(suggestion, index)}
                  className="w-full flex items-center gap-3 px-4 py-3 hover:bg-muted transition-smooth text-left"
                >
                  <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                    <Icon name={suggestion?.icon} size={20} color="var(--color-primary)" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="font-body font-medium text-sm text-popover-foreground truncate">
                      {suggestion?.name}
                    </p>
                    <p className="font-caption text-xs text-muted-foreground">
                      {suggestion?.category}
                    </p>
                  </div>
                  <Icon name="ChevronRight" size={16} className="text-muted-foreground flex-shrink-0" />
                </button>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SearchBar;